import { handleHttpResponse } from "../../utils/http_response_utils";

export const getScraperLogStreams = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-scraper-log-streams", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getAuto4clientLogStreams = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-auto4client-log-streams", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getDataCheckerLogStreams = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-data-checker-log-streams", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getLogEvents = async (logStreamName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch(
    "/api/get-log-stream-events?" + new URLSearchParams({ logStreamName: logStreamName }).toString(),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return await handleHttpResponse(response);
};
